import React from "react";
import { Animated, StyleSheet } from "react-native";

export const ClipView = (props) => {
    let { animation, startValues={}, endValues={}, inputRange, outputRange, ...rest } = props;
    const { width: startWidth = "0%", height: startHeight = "0%" } = startValues;
    const { width: endWidth = "100%", height: endHeight = "100%" } = endValues;

    inputRange = inputRange ?? [0, 1];
    outputRange = outputRange ?? [`polygon(0 0, ${startWidth}px 0, ${startWidth}px ${startHeight}, 0% ${startHeight})`, `polygon(0 0, ${endWidth}px 0, ${endWidth}px ${endHeight}, 0% ${endHeight})`];

    const animatedViewProps = {
        ...rest,
        style: StyleSheet.flatten([
            {
                clipPath: animation.interpolate({
                    inputRange,
                    outputRange,
                })
            },
            props.style,
        ])
    }

    return <Animated.View {...animatedViewProps}></Animated.View>
}